export default {

    lista: {
        method: 'get',
        url: 'cargohoraria/trabalhador/lista'
    },
    // pesquisa:{
    //     method:'get',
    //     url:'boletins/tabela/pesquisa{/id}'
    // },
    cadastra: {
        method: 'post',
        url: 'cargohoraria/trabalhador/cadastro'
    },
    delete: {
        method: 'delete',
        url: 'cargohoraria/trabalhador/deletar{/id}'
    },
    editar: {
        method: 'get',
        url: 'cargohoraria/trabalhador/editar{/id}'
    },
    update: {
        method: 'post',
        url: 'cargohoraria/trabalhador/update'
    },
    show: {
        method: 'get',
        url: 'cargohoraria/trabalhador/busca'
    },
    pesquisa: {
        method: 'get',
        url: 'cargohoraria/trabalhador/busca{/id}'
    }
}